// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file responses/v1/enabled_shipping_types_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/enabled_shipping_types_response.proto.
 */
export const file_responses_v1_enabled_shipping_types_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CjJyZXNwb25zZXMvdjEvZW5hYmxlZF9zaGlwcGluZ190eXBlc19yZXNwb25zZS5wcm90bxIMcmVzcG9uc2VzLnYxIoMCChxFbmFibGVkU2hpcHBpbmdUeXBlc1Jlc3BvbnNlEj0KBGRhdGEYASADKAsyLy5yZXNwb25zZXMudjEuRW5hYmxlZFNoaXBwaW5nVHlwZXNSZXNwb25zZS5EYXRhGqMBCgREYXRhEhQKDGNvdW50cnlfY29kZRgBIAEoCRJPCglwcm92aWRlcnMYAiADKAsyPC5yZXNwb25zZXMudjEuRW5hYmxlZFNoaXBwaW5nVHlwZXNSZXNwb25zZS5EYXRhLlByb3ZpZGVyRGF0YRo0CgxQcm92aWRlckRhdGESDAoEbmFtZRgBIAEoCRIWCg5zaGlwcGluZ190eXBlcxgCIAMoCUKMAQoQY29tLnJlc3BvbnNlcy52MUIhRW5hYmxlZFNoaXBwaW5nVHlwZXNSZXNwb25zZVByb3RvUAFaBC4vcGKiAgNSWFiqAgxSZXNwb25zZXMuVjHKAgxSZXNwb25zZXNcVjHiAhhSZXNwb25zZXNcVjFcR1BCTWV0YWRhdGHqAg1SZXNwb25zZXM6OlYxYgZwcm90bzM'
    );

/**
 * @generated from message responses.v1.EnabledShippingTypesResponse
 */
export type EnabledShippingTypesResponse = Message<'responses.v1.EnabledShippingTypesResponse'> & {
    /**
     * @generated from field: repeated responses.v1.EnabledShippingTypesResponse.Data data = 1;
     */
    data: EnabledShippingTypesResponse_Data[];
};

/**
 * Describes the message responses.v1.EnabledShippingTypesResponse.
 * Use `create(EnabledShippingTypesResponseSchema)` to create a new message.
 */
export const EnabledShippingTypesResponseSchema: GenMessage<EnabledShippingTypesResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_enabled_shipping_types_response, 0);

/**
 * @generated from message responses.v1.EnabledShippingTypesResponse.Data
 */
export type EnabledShippingTypesResponse_Data = Message<'responses.v1.EnabledShippingTypesResponse.Data'> & {
    /**
     * @generated from field: string country_code = 1;
     */
    countryCode: string;

    /**
     * @generated from field: repeated responses.v1.EnabledShippingTypesResponse.Data.ProviderData providers = 2;
     */
    providers: EnabledShippingTypesResponse_Data_ProviderData[];
};

/**
 * Describes the message responses.v1.EnabledShippingTypesResponse.Data.
 * Use `create(EnabledShippingTypesResponse_DataSchema)` to create a new message.
 */
export const EnabledShippingTypesResponse_DataSchema: GenMessage<EnabledShippingTypesResponse_Data> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_enabled_shipping_types_response, 0, 0);

/**
 * @generated from message responses.v1.EnabledShippingTypesResponse.Data.ProviderData
 */
export type EnabledShippingTypesResponse_Data_ProviderData =
    Message<'responses.v1.EnabledShippingTypesResponse.Data.ProviderData'> & {
        /**
         * @generated from field: string name = 1;
         */
        name: string;

        /**
         * @generated from field: repeated string shipping_types = 2;
         */
        shippingTypes: string[];
    };

/**
 * Describes the message responses.v1.EnabledShippingTypesResponse.Data.ProviderData.
 * Use `create(EnabledShippingTypesResponse_Data_ProviderDataSchema)` to create a new message.
 */
export const EnabledShippingTypesResponse_Data_ProviderDataSchema: GenMessage<EnabledShippingTypesResponse_Data_ProviderData> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_enabled_shipping_types_response, 0, 0, 0);
